import { Box, Button } from "@mui/material";
// import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Flex from "../../../../../../../../../../../components/Flex";
import { useQueryParams } from "../../../../../../../../../../../hooks/use-query-param";
import { useReduceDisclosure } from "../../../../../../../../../../../hooks/use-reduce-disclosure";
import { useGetOrderPrescription } from "../../../../../../../../../../../queries/patient-chart/order/prescription/get-all-prescription";
// import { usePrescriptionPrintById } from "../../../../../../../../../../../queries/patient-chart/order/prescription/use-get-prescription-print-by-uuid";
import Text from "../../../../../../../../../../../components/Text";
import useCurrentUser from "../../../../../../../../../../../hooks/local-storage/use-current-user";
import { useArchivePrescription } from "../../../../../../../../../../../queries/patient-chart/order/prescription/use-prescription-archive";
import { useArchiveOrder } from "../../../../../../../../../../../queries/patient-chart/order/use-archive-order";
import { useGetOrders } from "../../../../../../../../../../../queries/patient-chart/order/use-get-orders";
import { useGetPatientScriptsureUrl } from "../../../../../../../../../../../queries/script-sure/use-get-patient-scriptsure-url";
import { useArchiveVaccine } from "../../../../../../../../../../../queries/vaccines/use-patient-vaccine-archive";
import { usePatientVaccinesList } from "../../../../../../../../../../../queries/vaccines/use-patient-vaccines";
import { GetScriptsureProfileUrlTypeEnum } from "../../../../../../../../../../../services";
import { NonNullableDate } from "../../../../../../../../../../../utils/date-time-utility";
import {
  DEFAULT_UUID_NAME_LIST,
  DEFAULT_VALUE_LABEL_LIST,
  DEF_PAGINATION,
  getXtenantId,
  replaceUnderScoreAddSpace,
  transformMultiSelectFrontEndVal,
} from "../../../../../../../../../../../utils/utils";
import UpsertLabRequisitionForm from "../../../../../../../../scheduling/appointment/encounter/default-forms/UpsertLabRequisitionForm";
import { StyleAddButton } from "../../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import UpsertPrescriptionForm from "../../../../../../../../scheduling/appointment/encounter/prescription/UpsertPrescriptionForm";
import PrintOrders from "../../../../../order/orders/PrintOrders";
import { getTransPayload } from "../../../../../order/prescription/OrderPrescriptionTableNew";
import { PrescriptionsPopUp } from "../../../../../order/prescription/PrescriptionsPopUp";
import UpsertVaccineDrawer from "../../../../../vaccines/UpsertVaccineDrawer";
import UpsertVitalFormDrawerNew from "../../../../../vitals/UpsertVitalFormDrawerNew";
import { AddCptCodes, renderSelectedCptCodes } from "../Add-CPT-Codes";
import PreviewContentWrapper from "../PreviewContentWrapper";
import { PrescriptionPreview } from "../PsychiatricNotePlan";
import ReferringOutPatientWrapper from "../ReferringOutPatientWrapper";
import SendPatientAssementFormsModal from "../../../../../assessment/PatientAssementForms/SendPatientAssementFormsModal";
import AssignEducationMaterial from "../../../../../education-material/AssignEducationMaterial";
import CommonlyUsedTherapiesModal from "../InitialPsychotherapy/modals/CommonlyUsedTherapiesModal";
import { useGetAllTherapyNotes } from "../../../../../../../../../../../queries/encounter/use-get-all-therapy-notes";
import { useArchiveTherapyNote } from "../../../../../../../../../../../queries/encounter/use-archive-therapy-note";
import DeleteModal, {
  useDeleteDisClosure,
} from "../../../../../../../../../../../components/app/DeleteModal";

const PrimaryCareSoapNotePlan = (props: any) => {
  const { formik, showSendAssessment, showAssignEducation, showTherapies } =
    props;
  const [
    addVitalDisclosure,
    cptDisclosure,
    prescriptionDisclosure,
    ordersDisclosure,
    vaccineDisclosure,
    referralDisclosure,
    printViewDisclosure,
    printOrderDisclosure,
    sendAssessmentDisclosure,
    assignEducationDisclosure,
    therapiesDisclosure,
  ] = useReduceDisclosure(12);
  const { patientId } = useParams() as { patientId: any };
  const [showIframe, setShowIframe] = useState(false);
  const [shouldFetchUrl, setShouldFetchUrl] = useState(false);
  const user = sessionStorage.getItem("user");
  const providerId = user ? JSON.parse(user ?? "")?.uuid : null;
  const appointmentId = useQueryParams("appointmentid");

  const {
    data: patientScriptsureUrl,
    isLoading,
    error,
  }: any = useGetPatientScriptsureUrl({
    patientUuid: patientId ?? "",
    providerId: providerId ?? "",
    xTENANTID: getXtenantId() ?? "",
    type: GetScriptsureProfileUrlTypeEnum.Prescription,
    enabled: shouldFetchUrl, // Only fetch when shouldFetchUrl is true
  });

  const handleOpenIframe = () => {
    setShowIframe(true);
  };

  const handleCloseIframe = () => {
    setShowIframe(false);
  };

  const handleElectronicPrescription = () => {
    setShouldFetchUrl(true);
  };
  // Effect to handle successful API response
  React.useEffect(() => {
    if (shouldFetchUrl && patientScriptsureUrl?.data && !isLoading && !error) {
      handleOpenIframe();
      setShouldFetchUrl(false); // Reset the flag
    }
  }, [shouldFetchUrl, patientScriptsureUrl, isLoading, error]);

  const { mutateAsync: archivePrescription } = useArchivePrescription();
  const { data: allPrescription, refetch } = useGetOrderPrescription({
    appointmentUuid: formik.values?.appointmentId ?? appointmentId ?? "",
    pagination: DEF_PAGINATION,
    patientUuid: patientId as any,
    archive: false,
    xTENANTID: getXtenantId(),
  });

  const { data: orders, refetch: refetchOrders } = useGetOrders({
    appointmentUuid: formik.values?.appointmentId ?? appointmentId ?? "",
    archive: false,
    pagination: DEF_PAGINATION,
    xTENANTID: getXtenantId(),
  });

  const { mutateAsync: archiveOrder } = useArchiveOrder();

  // therapies linked to this appointment (ECRH-5428)
  const effectiveAppointmentId =
    formik.values?.appointmentId ?? appointmentId ?? "";
  const { data: linkedTherapies, refetch: refetchTherapies } =
    useGetAllTherapyNotes({
      appointmentId: effectiveAppointmentId || undefined,
      enabled: !!effectiveAppointmentId,
    });
  const { mutateAsync: archiveTherapyNote } = useArchiveTherapyNote();
  const therapyDeleteDisc = useDeleteDisClosure();

  function therapyDeleteHandler(uuid: string) {
    return archiveTherapyNote({
      appointmentUuid: effectiveAppointmentId,
      therapyNoteUuid: uuid,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetchTherapies();
      return res;
    });
  }

  const { mutateAsync: archiveVaccine } = useArchiveVaccine();
  const { data: vaccineList, refetch: refetchVaccine } = usePatientVaccinesList(
    {
      appointmentId: formik.values?.appointmentId ?? appointmentId ?? "",
      // patientUuid: patientId as string,
      pagination: DEF_PAGINATION,
      archive: false,
      xTENANTID: getXtenantId(),
    }
  );

  function vaccineArchiveHandler<T>(value: boolean, id: T) {
    return archiveVaccine({
      patientVaccineId: id?.toString() ?? "",
      status: value,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetchVaccine();
      return res;
    });
  }
  function orderArchiveHandler<T>(value: boolean, id: T) {
    return archiveOrder({
      patientOrderId: id?.toString() ?? "",
      status: value,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetchOrders();
      return res;
    });
  }

  function prescriptionArchiveHandler<T>(value: boolean, id: T) {
    return archivePrescription({
      prescriptionFormId: id?.toString() ?? "",
      status: value,
      xTENANTID: getXtenantId(),
    }).then((res) => {
      refetch();
      return res;
    });
  }
  const [prefillData, setPrefillData] = useState<any>(null);
  //  const { mutateAsync: printPrescription } = usePrescriptionPrintById();
  // const queryClient = useQueryClient();
  const getReferralPrint = async (prescriptionId: string) => {
    // printPrescription({
    //   prescriptionFormId: prescriptionId,
    //   hasStatusChange: true,
    //   xTENANTID: getXtenantId() as string,
    // }).then((res) => {
    //   const blob = new Blob([res?.data], { type: "application/pdf" });
    //   const fileUrl = URL.createObjectURL(blob);
    //   printViewDisclosure.open(fileUrl);
    // });
    printViewDisclosure.open(prescriptionId);
  };

  const [me] = useCurrentUser();

  return (
    <>
      {!!formik.values?.procedureCodes?.length && (
        <Flex flexDirection={"column"} width={"100%"} gap={1}>
          {/* <Text fontWeight={"bold"}>CPT Codes</Text> */}
          {renderSelectedCptCodes(
            formik.values?.procedureCodes ?? [],
            (code: any) => {
              formik.setFieldValue("procedureCodes", [
                ...(formik.values?.procedureCodes ?? []).filter(
                  (it: any) => it.value !== code.value
                ),
              ]);
            },
            "20vh"
          )}
        </Flex>
      )}
      {/* prescription */}
      {!!allPrescription?.data?.content?.length && (
        <PrescriptionPreview
          data={allPrescription?.data?.content}
          onDelete={(uuid) => {
            prescriptionArchiveHandler(true, uuid).then(() => {});
          }}
          onEdit={(prescription) => {
            setPrefillData(getTransPayload(prescription));
            prescriptionDisclosure.open(prescription.uuid);
          }}
        />
      )}
      {/* vaccine */}
      {!!vaccineList?.data?.content?.length && (
        <PreviewContentWrapper
          dataList={vaccineList?.data?.content}
          k="vaccine"
          title="Immunizations"
          renderContent={(vaccine: any) => {
            // Match the encounter-summary Immunizations format
            // ({name} : {dose} {units} by {route} on {site}) — ECRH-5428.
            const detail = [
              vaccine?.dose || "",
              vaccine?.units || "",
              vaccine?.route
                ? `by ${replaceUnderScoreAddSpace(vaccine.route.toLowerCase())}`
                : "",
              vaccine?.site
                ? `on ${replaceUnderScoreAddSpace(vaccine.site.toLowerCase())}`
                : "",
            ]
              .filter(Boolean)
              .join(" ");
            return (
              <Text sx={{ color: "#424242" }}>
                {`${vaccine?.vaccine?.name || "-"}${
                  detail ? ` : ${detail}` : ""
                }`}
              </Text>
            );
          }}
          onDelete={(uuid) => {
            vaccineArchiveHandler(true, uuid).then(() => {});
          }}
          onEdit={(vaccine) => {
            vaccineDisclosure.open({
              ...vaccine,
              vaccine: {
                value: vaccine?.vaccine?.uuid,
                label: vaccine?.vaccine?.name,
              },
              administeredBy: {
                value: Object.keys(vaccine?.administeredBy)[0],
                label: Object.values(vaccine?.administeredBy)[0],
              },
            });
          }}
        />
      )}
      {/* orders */}
      {!!orders?.data?.content?.length && (
        <PreviewContentWrapper
          dataList={orders?.data?.content}
          k="order"
          title="Orders"
          renderContent={(it) => (
            <Flex flexDirection={"column"} gap={1}>
              <Text>{`${it?.orderTitle || ""}, ${
                it?.orderType ?? ""
              } - ${NonNullableDate(it?.appointmentDate)} - ${
                it?.providerName
              } `}</Text>
              <Flex flexDirection={"column"} gap={0.5}>
                <Text fontWeight={"bold"}>Tests:</Text>
                {it?.tests
                  ? Object.values(it?.tests ?? {}).map(
                      (it: any, ind: number) => {
                        return (
                          <Flex key={it.uuid} gap={0.5}>
                            <Text>{ind + 1}.</Text>
                            <Text>{it}</Text>
                          </Flex>
                        );
                      }
                    )
                  : ""}
              </Flex>
            </Flex>
          )}
          onPrint={(uuid) => {
            printOrderDisclosure.open(uuid);
          }}
          onDelete={(uuid) => orderArchiveHandler(true, uuid).then(() => {})}
          onEdit={(order) => {
            const transformedData = {
              ...order,
              location: transformMultiSelectFrontEndVal(
                DEFAULT_UUID_NAME_LIST,
                order?.location
              ),
              labs: transformMultiSelectFrontEndVal(
                DEFAULT_VALUE_LABEL_LIST,
                order?.labs
              ),
              tests: transformMultiSelectFrontEndVal(
                DEFAULT_UUID_NAME_LIST,
                order?.tests
              ),
              medicalCodes: transformMultiSelectFrontEndVal(
                DEFAULT_UUID_NAME_LIST,
                order?.medicalCodes
              ),
              imagingCenter: order?.imagingCenter ?? undefined,
              primaryProvider: order?.primaryProvider
                ? {
                    value: Object.keys(order.primaryProvider)[0],
                    label: Object.values(order.primaryProvider)[0],
                  }
                : undefined,
              orderingProvider: order?.orderingProvider
                ? {
                    value: Object.keys(order.orderingProvider)[0],
                    label: Object.values(order.orderingProvider)[0],
                  }
                : undefined,
              patientInstructions: order?.patientInstruction ?? undefined,
            };

            ordersDisclosure.open(transformedData);
          }}
        />
      )}
      {/* therapies */}
      {showTherapies && !!linkedTherapies?.data?.content?.length && (
        <PreviewContentWrapper
          dataList={linkedTherapies?.data?.content}
          k="therapy"
          title="Therapies"
          renderContent={(therapy: any) => (
            <Flex flexDirection={"column"} gap={0.5}>
              <Text sx={{ color: "#424242" }}>{therapy?.name || "-"}</Text>
              {therapy?.description && (
                <Text sx={{ color: "#757575", fontSize: "12px" }}>
                  {therapy.description}
                </Text>
              )}
            </Flex>
          )}
          onDelete={(uuid) => {
            therapyDeleteDisc.open(uuid);
          }}
          onEdit={() => {
            therapiesDisclosure.open();
          }}
        />
      )}
      <DeleteModal
        w="380px"
        open={therapyDeleteDisc.opened}
        onClose={therapyDeleteDisc.close}
        id={therapyDeleteDisc.deleteId}
        onConfirmation={(uuid) => therapyDeleteHandler(uuid ?? "")}
        content={`You want to Delete this Therapy`}
      />
      {/* Action Buttons */}
      <Flex gap={1} flexWrap="wrap" sx={{ mb: 1 }}>
        <PrescriptionsPopUp
          buttonType="rxButton"
          variant="outlined"
          title="eRx"
          onOptionClick={(v: string) => {
            if (v === "paper_prescription") {
              prescriptionDisclosure.open();
            } else if (v === "eletronic_prescription") {
              handleElectronicPrescription();
            }
          }}
        />
        <StyleAddButton
          w="80px"
          onClick={() => {
            ordersDisclosure.open();
          }}
          label="Orders"
        />
        <StyleAddButton
          w="80px"
          onClick={() => {
            vaccineDisclosure.open();
          }}
          label="Immunization"
        />
        <StyleAddButton
          w="80px"
          onClick={() => {
            cptDisclosure.open();
          }}
          label="Add CPT Codes"
        />
        <StyleAddButton
          w="120px"
          onClick={() => {
            referralDisclosure.open();
          }}
          label="Referral Out"
        />
        {showSendAssessment && (
          <StyleAddButton
            w="140px"
            onClick={() => {
              sendAssessmentDisclosure.open();
            }}
            label="Send Assessments"
          />
        )}
        {showAssignEducation && (
          <StyleAddButton
            w="180px"
            onClick={() => {
              assignEducationDisclosure.open({ patientId });
            }}
            label="Assign Education Material"
          />
        )}
        {showTherapies && (
          <StyleAddButton
            w="140px"
            onClick={() => {
              therapiesDisclosure.open();
            }}
            label="Add Therapies"
          />
        )}
      </Flex>

      <UpsertVitalFormDrawerNew disclosureHost={addVitalDisclosure} />
      <AddCptCodes formik={formik} disclosureHost={cptDisclosure} />
      <UpsertPrescriptionForm
        prefillData={prefillData}
        setPrefillData={setPrefillData}
        disclosureHost={prescriptionDisclosure}
        readOnly={false}
        onOrder={(id: string) => getReferralPrint(id)}
        isVisitNote={true}
        icdCodes={
          formik.values?.assessmentCodes?.map((it: any) => ({
            value: it?.value,
            label: it?.code,
          })) ?? []
        }
      />
      <UpsertLabRequisitionForm disclosureHost={ordersDisclosure} />
      <UpsertVaccineDrawer
        disclosureHost={vaccineDisclosure}
        administeredBy={
          vaccineDisclosure?.data
            ? undefined
            : {
                value: me?.uuid ?? "",
                label: `${me?.firstName} ${me?.lastName}`,
              }
        }
      />
      <ReferringOutPatientWrapper
        referralDisclosure={referralDisclosure}
        referralDiagnosisCode={formik.values?.assessmentCodes?.map(
          (it: any) => ({ value: it.value, label: it.code })
        )}
      />
      <PrintOrders disclosureHost={printOrderDisclosure} />
      {showSendAssessment && (
        <SendPatientAssementFormsModal
          disclosureHost={sendAssessmentDisclosure}
        />
      )}
      {showAssignEducation && (
        <AssignEducationMaterial disclosureHost={assignEducationDisclosure} />
      )}
      {showTherapies && (
        <CommonlyUsedTherapiesModal disclosureHost={therapiesDisclosure} />
      )}
      {showIframe && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "90%",
              height: "90%",
              backgroundColor: "white",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <Button
              onClick={handleCloseIframe}
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: 10000,
                backgroundColor: "white",
                color: "black",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
              variant="contained"
              size="small"
            >
              Close
            </Button>
            <iframe
              src={patientScriptsureUrl?.data}
              // src="https://ssu.scriptsure.com/profile/193676?darkmode=off&sessiontoken=fpKpd8rVbMiUe45TajD_afSyzFqSliGI"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "8px",
              }}
              title="ScriptSure Patient Profile"
              allow="camera; microphone; geolocation"
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default PrimaryCareSoapNotePlan;
